"use client";

import React from "react";
import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
const scheduleData = [{
  date: "12 Oktober 2024",
  time: "19:00 WIB",
  title: "Bincang Santai: Membangun Karakter Bangsa"
}, {
  date: "15 Oktober 2024",
  time: "20:00 WIB",
  title: "Debat Terbuka: Arah Kebijakan Ekonomi Nasional"
}, {
  date: "20 Oktober 2024",
  time: "18:30 WIB",
  title: "Laporan Khusus: Suara dari Daerah Pemilihan"
}, {
  date: "28 Oktober 2024",
  time: "19:00 WIB",
  title: "Peringatan Sumpah Pemuda: Peran Generasi Emas"
}];
export default function JadwalLiveMendatang() {
  return <section id="jadwal-live-mendatang" className="bg-background py-12 md:py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
            Jadwal Live Mendatang
          </h2>
        </div>
        
        <div className="flex flex-col">
          {scheduleData.map((item, i) => <div key={i} data-index={i} className="flex flex-col lg:flex-row items-start lg:items-center justify-between py-8 border-b border-border last:border-0 gap-4 lg:gap-0 transition-colors hover:bg-muted/20">
              <div className="w-full lg:w-64 shrink-0">
                <p className="text-secondary font-bold text-lg md:text-xl lg:text-2xl tracking-wide">
                  {item.date}
                </p>
                <p className="text-secondary/80 font-medium mt-1">
                  {item.time}
                </p>
              </div>
              
              <div className="flex-1 w-full lg:px-8">
                <h3 className="text-foreground font-sans text-xl md:text-2xl lg:text-3xl font-medium leading-tight">
                  {item.title}
                </h3>
              </div>
              
              <div className="shrink-0 w-full lg:w-auto mt-2 lg:mt-0">
                <Button variant="outline" className="w-full lg:w-auto border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                  <Bell className="mr-2 h-4 w-4" />
                  Ingatkan Saya
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}